import { vfsContentNamespace } from '@/convex/vfs/content_namespace';
import {
  avatarRouteSegment,
  workspaceAvatarReturnPath,
  workspaceFilesAvatarListHref,
} from '@/convex/products/ai/navigation/workspace_entity_routes.helpers';

// One implementation shared with Convex navigation, which must build the same URLs.
export {
  workspaceFilesAvatarDetailHref,
  workspaceFilesAvatarListHref,
} from '@/convex/products/ai/navigation/workspace_entity_routes.helpers';

export function getWorkspaceAvatarDetailKind(
  routeSegment: string,
  source: string | null | undefined
): 'workspace' | 'legacy' | 'unknown' {
  if (routeSegment.includes('--')) return 'workspace';
  return source === 'legacy' ? 'legacy' : 'unknown';
}

export function workspaceFilesLegacyAvatarDetailHref(args: {
  orgSlug: string;
  avatarId: string;
}): string {
  return `${workspaceFilesAvatarListHref(args.orgSlug)}/${encodeURIComponent(args.avatarId)}?source=legacy`;
}

export function workspaceFilesAvatarBackHref(args: {
  orgSlug: string;
  returnTo: string | null | undefined;
}): string {
  return (
    workspaceAvatarReturnPath(args) ??
    workspaceFilesAvatarListHref(args.orgSlug)
  );
}

export function resolveWorkspaceFilesAvatarPath(args: {
  orgSlug: string;
  routeSegment: string;
  requestedAvatarPath: string | null | undefined;
  resolvedAvatarPath?: string | null;
}): string | null {
  const { orgSlug, routeSegment, requestedAvatarPath, resolvedAvatarPath } =
    args;
  // The path comes from the authenticated native-avatar query. A URL hint
  // cannot establish a binding or substitute a different same-named folder.
  if (
    !resolvedAvatarPath ||
    avatarRouteSegment(resolvedAvatarPath) !== routeSegment ||
    (requestedAvatarPath != null && requestedAvatarPath !== resolvedAvatarPath)
  ) {
    return null;
  }
  const namespace = vfsContentNamespace({
    workspaceStorageSlug: orgSlug,
    path: resolvedAvatarPath,
    kind: 'directory',
  });
  return namespace === 'home' || namespace === 'drive'
    ? resolvedAvatarPath
    : null;
}
